module.exports = __webpack_public_path__ + "img/stats_inline.e0f54c57.png";